import { Box, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getClientData } from "src/clients/ClientService";
import { selectUser } from "src/redux/slices/userSlice";
import { ClientData } from "src/types/ClientDetails";
import TabComponent from "./TabComponent";

const TabSubComponent = () => {
  const user = useSelector(selectUser);
  const [initialValue, setInitialValue] = useState<ClientData>();
  useEffect(() => {
    getClientData(user.userId, user.password, user.clientCode).then(
      async (res) => {
        const data = await res.json();
        setInitialValue(data);
      }
    );
  }, []);
  if (!initialValue) {
    return (
      <Box className="loaderIconStylings">
        <CircularProgress disableShrink />
      </Box>
    );
  }

  return (
    <TabComponent
      mode={"Edit"}
      selectedClient={initialValue}
      productsList={[]}
      handleOnCreateClientCancel={function (): void {
        throw new Error("Function not implemented.");
      }}
    />
  );
};

export default TabSubComponent;
